export type ChangeEventPayload = {
  value: string;
};

export type ExpoWifiRttViewProps = {
  name: string;
};
